// ─── Cart Limit Modal (singleton) ──────────────────────────────────────────
const CART_LIMIT_MSG = "We're sorry, this item was not added to your cart because the quantity chosen exceeds the cart limit of 30 items.";
function showCartLimitModal() {
  const MODAL_ID = 'cart-limit-modal-hco';

  // Always remove stale instance so listeners & styles stay fresh
  const existing = document.getElementById(MODAL_ID);
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = MODAL_ID;
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-labelledby', 'cart-limit-modal-heading');
  modal.innerHTML = `
    <div class="cart-limit-modal__box">
      <button class="cart-limit-modal__close" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none"
             stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
             width="14" height="14" aria-hidden="true">
          <line x1="1" y1="1" x2="11" y2="11"/>
          <line x1="11" y1="1" x2="1" y2="11"/>
        </svg>
      </button>
      <div class="cart-limit-modal__body">
        <div class="cart-limit-modal__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
               width="40" height="40">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        <h2 class="cart-limit-modal__heading" id="cart-limit-modal-heading">Maximum Quantity</h2>
        <p class="cart-limit-modal__desc">${CART_LIMIT_MSG}</p>
      </div>
    </div>
  `;

  // Re-inject styles every time (ensures latest values are always applied)
  const existingStyle = document.getElementById('cart-limit-modal-styles');
  if (existingStyle) existingStyle.remove();

  const style = document.createElement('style');
  style.id = 'cart-limit-modal-styles';
  style.textContent = `
    #cart-limit-modal-hco {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-top: 20vh;
      background: rgba(0, 0, 0, 0.6);
      cursor: pointer;
    }
    .cart-limit-modal__box {
      position: relative;
      z-index: 1;
      background: #fff;
      width: 580px;
      min-height: 285px;
      max-width: 94vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 48px 48px 40px;
      box-shadow: 0 8px 48px rgba(0,0,0,0.32), 0 2px 12px rgba(0,0,0,0.14);
      border-radius: 8px;
    }
    .cart-limit-modal__close {
      position: absolute;
      top: 14px;
      right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      color: #777;
      padding: 4px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cart-limit-modal__close:hover { color: #111; }
    .cart-limit-modal__icon {
      color: #2d3e4f;
      margin-bottom: 2px;
    }
    .cart-limit-modal__body {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    .cart-limit-modal__heading {
      font-size: 20px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0;
      line-height: 1.3;
      font-family: inherit;
    }
    .cart-limit-modal__desc {
      font-size: 14px;
      color: #555;
      margin: 0;
      line-height: 1.6;
      max-width: 400px;
      font-family: inherit;
    }
  `;
  document.head.appendChild(style);

  // Measure header height so the overlay starts below it
  const headerEl = document.querySelector('.header-wrapper') || document.querySelector('header');
  const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
  modal.style.top = headerBottom + 'px';

  const closeModal = () => {
    modal.remove();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', escHandler);
  };
  const escHandler = (e) => { if (e.key === 'Escape') closeModal(); };

  // Lock scroll while modal is open
  document.body.style.overflow = 'hidden';
  document.body.appendChild(modal);

  // Click on backdrop (outer container) → close
  // Click inside the box → stop propagation so it doesn't bubble up
  modal.addEventListener('click', closeModal);
  modal.querySelector('.cart-limit-modal__box').addEventListener('click', (e) => e.stopPropagation());
  modal.querySelector('.cart-limit-modal__close').addEventListener('click', closeModal);
  document.addEventListener('keydown', escHandler);

  // Close modal when the cart drawer/icon button is clicked
  const cartTriggers = document.querySelectorAll(
    '#cart-icon-bubble, [href="/cart"], cart-drawer, .header__icon--cart, [data-drawer="cart-drawer"]'
  );
  cartTriggers.forEach((el) => {
    el.addEventListener('click', closeModal, { once: true });
  });
}
// ────────────────────────────────────────────────────────────────────────────


if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        // Safeguard: ensure variantIdInput exists before accessing it
        const variantInput = this.variantIdInput;
        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        // Prioritize cart-drawer over cart-notification
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        // Sync variant IDs removed: handled by product-info.js updateVariantInputs()
        // which triggers 'change' on all .product-variant-id within the same product section.
      }

      getSyncSubmitButtons() {
        const sectionId = this.dataset.sectionId;
        const selector = '.product-form__submit[name="add"]';
        if (!sectionId) {
          return this.querySelectorAll(selector);
        }

        return document.querySelectorAll(
          `product-form[data-section-id="${sectionId}"] ${selector}`,
        );
      }

      setSubmitButtonsLoadingState(isLoading) {
        this.getSyncSubmitButtons().forEach((button) => {
          if (isLoading) {
            button.setAttribute("aria-disabled", true);
            button.classList.add("loading");
          } else {
            button.classList.remove("loading");
            button.removeAttribute("aria-disabled");
          }

          const spinner = button.querySelector(".loading__spinner");
          if (spinner) {
            spinner.classList.toggle("hidden", !isLoading);
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Robust modal detection (loop + dataset fallback)
        let isModalSubmit = false;
        // Check dataset flag first (for manual/console)
        if (this.form.dataset.isModalSubmit === "true") {
          isModalSubmit = true;
        } else {
          // Fallback: Walk up parents
          let parent = this.form.parentElement;
          while (parent) {
            if (
              parent.tagName === "MODAL-DIALOG" &&
              parent.id.startsWith("StickyVariantModal-")
            ) {
              isModalSubmit = true;
              break;
            }
            parent = parent.parentElement;
          }
        }

        const context = this.closest("product-info") || document;

        const selectedSize = context.querySelector(
          '.size-picker input[type="radio"]:checked:not(.toggle-radio)',
        );
        const selectedLength = context.querySelector(
          '.length-picker input[type="radio"]:checked',
        );
        const sellength = context.querySelector(
          '.length-picker input[type="radio"]',
        );
        const sizeErrorEl =
          this.querySelector(".product-form__error-message-wrapper-variant") ||
          context.querySelector(".product-form__error-message-wrapper-variant");

        if (!selectedSize) {
          if (sizeErrorEl) {
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Size";
          }
          this.setSubmitButtonsLoadingState(false);
          return;
        }
        if (!selectedLength && sellength != null) {
          if (sizeErrorEl) {
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Length";
          }
          this.setSubmitButtonsLoadingState(false);
          return;
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.setSubmitButtonsLoadingState(true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const baseFormData = new FormData(this.form);
        const quantitySelect =
          this.form.querySelector('select[name="quantity"]') ||
          document.querySelector('select[name="quantity"]');

        let wasDisabled = false;
        if (quantitySelect && quantitySelect.disabled) {
          quantitySelect.disabled = false;
          wasDisabled = true;
        }

        if (wasDisabled && quantitySelect) {
          quantitySelect.disabled = true;
        }

        let quantityRaw = baseFormData.get("quantity");

        if (quantityRaw === null) {
          const quantitySelect =
            this.form.querySelector('select[name="quantity"]') ||
            document.querySelector('select[name="quantity"]');
          if (quantitySelect) {
            quantityRaw = quantitySelect.value;
          }
        }

        let quantity = parseInt(quantityRaw, 10);

        if (isNaN(quantity) || quantity <= 0) {
          quantity = 1;
        }

        const sections =
          typeof this.cart?.getSectionsToRender === "function"
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : ["cart-drawer", "cart-icon-bubble"];

        const getLocalePrefix = () => {
          const path = window.location.pathname;
          const match = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)/);
          return match ? "/" + match[1] : "";
        };

        const GENERIC_CART_ERROR_MESSAGE =
          "Sorry, we couldn't add this item. Please try again.";
        const TOO_MANY_REQUESTS_MESSAGE =
          "Too many requests. Please reload the page and try again.";
        const MAX_VARIANT_IN_CART_MESSAGE_PATTERN =
          /maximum quantity of this item is already in your cart/i;

        const isRateLimitedOrChallengeResponse = (status, rawText = "") =>
          status === 429 ||
          /too many requests|rate limit|temporarily unavailable|verifying your connection|connection needs to be verified|cdn-cgi\/challenge-platform|cf_chl_opt/i.test(
            rawText,
          );

        const getFriendlyCartErrorMessage = async (
          response,
          fallbackMessage = GENERIC_CART_ERROR_MESSAGE,
        ) => {
          const status = Number(response?.status) || 0;
          const contentType = response?.headers?.get("content-type") || "";
          let rawText = "";
          let errorData = null;

          if (response?.clone) {
            try {
              rawText = await response.clone().text();
            } catch (readError) {
              console.error("Failed reading cart error response:", readError);
            }
          }

          if (isRateLimitedOrChallengeResponse(status, rawText)) {
            return TOO_MANY_REQUESTS_MESSAGE;
          }

          if (!contentType.includes("text/html") && response?.clone) {
            try {
              errorData = await response.clone().json();
            } catch (parseError) {
              console.error("Failed parsing cart error JSON:", parseError);
            }
          }

          const combinedErrorText = [
            errorData?.description,
            errorData?.message,
            rawText,
          ]
            .filter(Boolean)
            .join(" ");

          if (
            status === 422 &&
            MAX_VARIANT_IN_CART_MESSAGE_PATTERN.test(combinedErrorText)
          ) {
            return "We're sorry, you've reached the maximum quantity for this item.";
          }

          return (
            errorData?.description ||
            errorData?.message ||
            fallbackMessage
          );
        };

        const getDisplayCartErrorMessage = (error) => {
          const message = String(error?.message || "");
          if (
            !message ||
            /unexpected token|unexpected end|json|html|failed to fetch|load failed/i.test(
              message,
            )
          ) {
            return GENERIC_CART_ERROR_MESSAGE;
          }

          return message;
        };

        const parseCartJsonResponse = async (
          response,
          fallbackMessage = GENERIC_CART_ERROR_MESSAGE,
        ) => {
          const contentType = response.headers.get("content-type") || "";
          if (!response.ok || contentType.includes("text/html")) {
            throw new Error(
              await getFriendlyCartErrorMessage(response, fallbackMessage),
            );
          }

          try {
            return await response.json();
          } catch (parseError) {
            console.error("Failed parsing cart JSON response:", parseError);
            throw new Error(fallbackMessage);
          }
        };

        const addItems = async (requestedQuantity) => {
          const formData = new FormData();
          for (let [key, value] of baseFormData.entries()) {
            if (key !== "quantity") formData.append(key, value);
          }

          formData.append("quantity", requestedQuantity);
          formData.append("sections", sections.join(","));
          formData.append("sections_url", window.location.pathname);
          formData.append("properties[_unique_id]", crypto.randomUUID());

          const res = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (!res.ok) {
            throw new Error(
              await getFriendlyCartErrorMessage(
                res,
                GENERIC_CART_ERROR_MESSAGE,
              ),
            );
          }
          await updateCustomerCartMetafield();
          return parseCartJsonResponse(res, GENERIC_CART_ERROR_MESSAGE);
        };

        const renderCartContents = async () => {
          const cartData = await fetch("/cart.js").then((res) =>
            parseCartJsonResponse(res, GENERIC_CART_ERROR_MESSAGE),
          );
          sessionStorage.setItem("cart_trial", JSON.stringify(cartData));

          if (window.innerWidth <= 1024 || isModalSubmit) {
            // Treat modal as "mobile-like" (notification only, no drawer/redirect)
            const notification = document.getElementById(
              "AddedToBagNotification",
            );

            // Detect ?app-view=true
            const urlParams = new URLSearchParams(window.location.search);
            const isAppView = urlParams.get("app-view") === "true";

            if (isAppView) {
              // Remove existing modal if any
              if (notification) notification.classList.add("hidden");

              // Create the app-view style flyout
              const existingFlyout = document.querySelector(
                ".app-view-add-to-bag-flyout",
              );
              if (existingFlyout) existingFlyout.remove();

              const flyout = document.createElement("div");
              flyout.className = "app-view-add-to-bag-flyout";
              flyout.innerHTML = `
      <div class="flyout-text">Item Added</div>
      <a href="/cart?app-view=true" class="flyout-btn">VIEW BAG </a>
    `;
              document.body.appendChild(flyout);

              // Auto-hide after 3s
              setTimeout(() => {
                flyout.remove();
              }, 3000);
            } else {
              // Default existing modal behavior
              if (notification) {
                notification.classList.remove("hidden");
                setTimeout(() => {
                  notification.classList.add("hidden");
                }, 3000);
              }
            }

            // Still update cart bubble as before
            try {
              const sectionsData = await fetch(
                `${getLocalePrefix()}/?sections=cart-icon-bubble`,
              ).then((res) =>
                parseCartJsonResponse(res, GENERIC_CART_ERROR_MESSAGE),
              );
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                const parsedBubble = new DOMParser()
                  .parseFromString(
                    sectionsData["cart-icon-bubble"],
                    "text/html",
                  )
                  .querySelector(".shopify-section");
                if (parsedBubble) {
                  bubble.innerHTML = parsedBubble.innerHTML;
                }
              }
            } catch (e) {
              console.error("Error updating cart bubble:", e);
            }

            return; // Always stop here for modal (no drawer attempt, no redirect)
          }

          // Desktop behavior (>1024px) → cart-drawer as usual (only for non-modal)
          const sectionsData = await fetch(
            `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`,
          ).then((res) =>
            parseCartJsonResponse(res, GENERIC_CART_ERROR_MESSAGE),
          );

          if (this.cart && typeof this.cart.renderContents === "function") {
            try {
              this.cart.renderContents({
                items: cartData.items,
                sections: sectionsData,
                total_price: cartData.total_price,
              });
            } catch (e) {
              console.error("Error rendering cart contents:", e);
              // For non-modal only, fallback to redirect on render error
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          }

          if (
            this.cart &&
            this.cart.tagName.toLowerCase() === "cart-drawer" &&
            typeof this.cart.open === "function"
          ) {
            try {
              this.cart.open(this.submitButton);
              this.cart.classList.add("animate", "active");
              this.cart.style.display = "block";
              this.cart.style.visibility = "visible";
            } catch (e) {
              console.error("Error opening cart drawer:", e);
              // For non-modal only, fallback to redirect on open error
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          } else {
            // fallback
            try {
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                bubble.dispatchEvent(new Event("click", { bubbles: true }));
              } else {
                // For non-modal only, fallback to redirect
                if (!isModalSubmit) {
                  window.location.href = "/cart";
                }
              }
            } catch (e) {
              console.error("Error triggering cart bubble:", e);
              // For non-modal only, fallback to redirect
              if (!isModalSubmit) {
                window.location.href = "/cart";
              }
            }
          }
        };

        (async () => {
          try {
            // ─── Pre-flight: enforce 30-item total cart limit ─────────────────
            const CART_ITEM_LIMIT = parseInt(this.dataset.cartLimit || '30', 10);
            let currentCartTotal = 0;
            try {
              const localePrefix = window.location.pathname.startsWith('/id') ? '/id' : '';
              const cartState = await fetch(`${localePrefix}/cart.js`).then((r) => r.json());
              currentCartTotal = cartState.item_count || 0;
            } catch (cartFetchErr) {
              console.warn('Could not fetch cart state for limit check:', cartFetchErr);
            }

            if (currentCartTotal + quantity > CART_ITEM_LIMIT) {
              const limitMsg = this.dataset.cartLimitMessage || `We're sorry, this item was not added because it exceeds the cart limit of ${CART_ITEM_LIMIT} items.`;
              const variantErrEl = this.querySelector('.product-form__error-message-wrapper-variant') || context.querySelector('.product-form__error-message-wrapper-variant') || document.querySelector('.product-form__error-message-wrapper-variant');
              if (variantErrEl) {
                const msgSpan = variantErrEl.querySelector('span');
                if (msgSpan) msgSpan.textContent = limitMsg;
                variantErrEl.style.display = 'block';
                setTimeout(() => { variantErrEl.style.display = 'none'; }, 6000);
              } else {
                this.handleErrorMessage(limitMsg);
              }
              this.setSubmitButtonsLoadingState(false);
              return; // abort — do not proceed to addItems()
            }
            // ─────────────────────────────────────────────────────────────────

            await addItems(quantity);

            const quickAddModal = this.closest("quick-add-modal");
            const stickyVariantModal = isModalSubmit
              ? this.closest('modal-dialog[id^="StickyVariantModal-"]')
              : null; // Detect sticky modal specifically

            if (quickAddModal) {
              // Existing quick-add logic (unchanged - hides modal and waits for close event)
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      renderCartContents,
                    );
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else if (stickyVariantModal) {

              const onModalHidden = () => {
                setTimeout(() => {
                  CartPerformance.measure(
                    "add:paint-updated-sections",
                    renderCartContents,
                  );
                });
              };

              // Listen for 'modalClosed' event if your modal dispatches it
              document.body.addEventListener("modalClosed", onModalHidden, {
                once: true,
              });

              // Reliable fallback: MutationObserver watches for 'open' attribute removal (modal hidden)
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.attributeName === "open" &&
                    !stickyVariantModal.hasAttribute("open")
                  ) {
                    onModalHidden();
                    observer.disconnect(); // Clean up
                  }
                });
              });
              observer.observe(stickyVariantModal, { attributes: true });

              // Trigger modal hide/close
              if (stickyVariantModal.hide) {
                stickyVariantModal.hide(true); // Preferred if custom element supports it
              } else {
                // Fallback: Simulate close button click or direct DOM manipulation
                const closeButton =
                  stickyVariantModal.querySelector(
                    "#ModalClose-sticky-{{ section.id }}",
                  ) ||
                  stickyVariantModal.querySelector(
                    ".sticky-variant-modal__toggle",
                  );
                if (closeButton) {
                  closeButton.click();
                } else {
                  stickyVariantModal.removeAttribute("open");
                  stickyVariantModal.classList.add("hidden");
                  document.body.classList.remove("overflow-hidden"); // If your theme uses this for body lock
                }
              }
            } else {
              CartPerformance.measure(
                "add:paint-updated-sections",
                renderCartContents,
              );
            }
          } catch (error) {
            console.error("Add to cart failed:", error);
            const errMsg = getDisplayCartErrorMessage(error);

            const isMaxQtyError =
              /you can only add/i.test(errMsg) ||
              /maximum quantity/i.test(errMsg) ||
              /already in your cart/i.test(errMsg) ||
              /items? of this/i.test(errMsg) ||
              /reached the maximum quantity/i.test(errMsg);

            let displayMsg = errMsg || GENERIC_CART_ERROR_MESSAGE;

            if (isMaxQtyError) {
              // 1. Try to parse the number from the Shopify error string (e.g. "You can only add 5 of this item")
              const parsedQty = (errMsg.match(/\b(\d+)\b/) || [])[1];

              // 2. Read from the quantity select: last option value or data-stock attribute
              const qtySelect = context.querySelector('select[name="quantity"]') || document.querySelector('select[name="quantity"]');
              let selectMax = null;
              if (qtySelect) {
                // data-stock is the most direct source
                const stock = parseInt(qtySelect.dataset.stock);
                if (!isNaN(stock) && stock > 0) {
                  selectMax = stock;
                } else {
                  // Fall back to last <option> value
                  const options = qtySelect.querySelectorAll('option');
                  if (options.length) {
                    selectMax = parseInt(options[options.length - 1].value) || null;
                  }
                }
              }

              const maxQty = parsedQty || selectMax;

              // Read translated templates from data-* attributes set by Liquid on <product-form>
              const variantBodyTpl = this.dataset.variantLimitMessage || null;
              const variantBodyFallback = this.dataset.variantLimitFallback || this.dataset.cartLimitMessage || '';
              const limitMsg = maxQty && variantBodyTpl
                ? variantBodyTpl.replace('__QTY__', maxQty)
                : variantBodyFallback;

              displayMsg = limitMsg;

              // Show in the existing ANF error-message variant div (in main-product.liquid)
              const variantErrEl = this.querySelector('.product-form__error-message-wrapper-variant') || context.querySelector('.product-form__error-message-wrapper-variant') || document.querySelector('.product-form__error-message-wrapper-variant');
              if (variantErrEl) {
                const msgSpan = variantErrEl.querySelector('span');
                if (msgSpan) msgSpan.textContent = displayMsg;
                variantErrEl.style.display = 'block';
                // Auto-clear after 6s
                setTimeout(() => { variantErrEl.style.display = 'none'; }, 6000);
              } else {
                this.handleErrorMessage(displayMsg);
              }
            } else {
              this.handleErrorMessage(displayMsg);
            }

            // ─── NEW: Show error in Sticky modal if this submit is from there ───────
            const modal = this.closest(
              'modal-dialog[id^="StickyVariantModal-"]',
            );
            if (modal && isModalSubmit) {
              const stickyError = modal.querySelector(".sticky-error-message");
              if (stickyError) {
                stickyError.textContent = displayMsg;
                stickyError.style.display = "block";
              }

              const errorWrapper = modal.querySelector(
                ".product-form__error-message-wrapper",
              );
              if (errorWrapper) {
                errorWrapper.removeAttribute("hidden");
                errorWrapper.style.display = "block";

                const errorMsg = errorWrapper.querySelector(
                  ".product-form__error-message",
                );
                if (errorMsg) {
                  errorMsg.textContent = displayMsg;
                }
              }
            }

            if (!isModalSubmit) {
              document.body.classList.remove("overflow-hidden");
            }
          } finally {
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            this.setSubmitButtonsLoadingState(false);
            CartPerformance.measureFromEvent("add:user-action", evt);
          }
        })();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const sectionId = this.dataset.sectionId;
        const selector = sectionId
          ? `product-form[data-section-id="${sectionId}"] .product-form__submit[name="add"]`
          : '.product-form__submit[name="add"]';
        const allButtons = document.querySelectorAll(
          selector,
        );

        allButtons.forEach((button) => {
          if (disable) {
            button.setAttribute("disabled", "disabled");
            if (text) {
              const span = button.querySelector("span");
              if (span) span.textContent = text;
            }
          } else {
            button.removeAttribute("disabled");
            const span = button.querySelector("span");
            if (span) {
              span.textContent = text || window.variantStrings.addToCart;
            }
          }
        });
      }

      // Utility method: Check if all variants are selected (scoped to context)
      isAllVariantsSelected(context = document) {
        if (context === document)
          context = this.closest("product-info") || document;
        const selectedSize = context.querySelector(
          '.size-picker input[type="radio"]:checked:not(.toggle-radio)',
        );
        const selectedLength = context.querySelector(
          '.length-picker input[type="radio"]:checked',
        );
        const sellength = context.querySelector(
          '.length-picker input[type="radio"]',
        );
        if (!context.querySelector(".size-picker")) return true;
        if (!selectedSize) {
          return false;
        }
        if (sellength && !selectedLength) {
          return false;
        }
        const selectedColor = context.querySelector(
          '.color-picker input[type="radio"]:checked',
        );
        if (context.querySelector(".color-picker") && !selectedColor) {
          return false;
        }
        return true;
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
